import React, { useEffect, useMemo, useRef, useState } from "react";
import SelectControl from "../SelecControl/SelectControl";
import { cargaMasivaOpciones, estructuraLectura, unidadesMedidasOpciones } from "../../utils/estructuras";

import {getDifferenceInDays} from '../../utils/funciones';

// Alertas
import Swal from 'sweetalert2'
import moment from "moment";

const ModalAssociateCKtoTDoc = ({activo,usuario,index = 0,minimizar, associateNroCKtoODT, componentePadre="", firstRender=true, fechaCompletado="", tDocsToAssociate, checklistSaved}) => {

    const [odtSelected,setOdtSelected] = useState(null);
    const [disableSave,setDisableSave] = useState(false);
    const saveClickedRef = useRef(false);

    const odtsModelated = useMemo(()=> tDocsToAssociate.map(o => ({label:`${o.tDocCodFor} ${o.tDocNroFor} - ${o.title}`, value:o._id}),[tDocsToAssociate]))

    const handleChange = (odtToSet) => {
        let selectedTDoc = tDocsToAssociate.filter(t => t._id == odtToSet.value)[0];
        setOdtSelected(selectedTDoc);
    }    

    const handleSaveAssociation = async(action = 'noAsociar') =>{
        if(!saveClickedRef.current){
            saveClickedRef.current = true;
            if(action == 'asociar'){
                let res = await associateNroCKtoODT(odtSelected.middleTable._id, checklistSaved.checkNro);
                if(res && Object.keys(res).length > 0){
                    Swal.fire({
                        title:'Asociación registrada correctamente!',
                        text: `Se asocio el checklist ${checklistSaved.checkNro} a la orden de trabajo ${res.nroTDoc}`,
                        icon:'success'
                    })
                    }  
                minimizar(true);
                saveClickedRef.current = false;
            }else{
                minimizar(false);
                saveClickedRef.current = false;
            }
        }
    }

    return <div className="modalFormDiv modalFormLecturaDiv modalFormAssociateCKtoTDoc">
        <button className="minimizarBtn" onClick={()=>minimizar(false,'close')}>X</button>
        <div className="headerModalForm">Asocie {checklistSaved.codigo} - {checklistSaved.checkNro} a una ODT</div>
        <div className="bodyModalForm">
            <div className="inputGroup">
                <label>Seleccione una Orden de Trabajo</label>
                <SelectControl componentePadre={componentePadre} placeholder={"Seleccione una OdT"} modo='Nuevo' idSelect={"lecturas"} handleChengeSelect={handleChange} optionsSelect={odtsModelated} valueSeleccionada={odtSelected ? odtsModelated.find(t => t.value == odtSelected._id) : {}} tipo={'odtToAssociate'} selectSelect={handleChange} index={index} setNuevoEditado={'Ninguno'} propToChange="uniMed"/>
            </div>
            <div className="btnsAssociate">
                <button className={`modalFormBtn notAssociate ${(disableSave) ? 'disabledBtn' : ''}`} disabled={!odtSelected} onClick={()=>handleSaveAssociation()}>No Asociar</button>
                <button className={`modalFormBtn ${(disableSave) ? 'disabledBtn' : ''}`} disabled={!odtSelected} onClick={()=>handleSaveAssociation('asociar')}>Asociar</button>
            </div>
        </div>
    </div>

}

export default ModalAssociateCKtoTDoc;